function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

var _ref2 = /*#__PURE__*/React.createElement("path", {
  d: "M15.9993 2.66675C8.65268 2.66675 2.66602 8.65341 2.66602 16.0001C2.66602 23.3467 8.65268 29.3334 15.9993 29.3334C23.346 29.3334 29.3327 23.3467 29.3327 16.0001C29.3327 8.65341 23.346 2.66675 15.9993 2.66675ZM22.3727 12.9334L14.8127 20.4934C14.626 20.6801 14.3727 20.7867 14.106 20.7867C13.8393 20.7867 13.586 20.6801 13.3993 20.4934L9.62602 16.7201C9.23935 16.3334 9.23935 15.6934 9.62602 15.3067C10.0127 14.9201 10.6527 14.9201 11.0393 15.3067L14.106 18.3734L20.9594 11.5201C21.346 11.1334 21.986 11.1334 22.3727 11.5201C22.7593 11.9067 22.7593 12.5334 22.3727 12.9334Z",
  fill: "#F05123"
});

function SvgTickCircle(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ref2);
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgTickCircle);
export default __webpack_public_path__ + "static/media/tick-circle.e99b44aa.svg";
export { ForwardRef as ReactComponent };